import * as config from '../../../wips.config.js';
import { getStandorte } from '../../../helpers/getStandorte';
import { IDs } from '../../../helpers/IDs';
import { RoutingIDs } from '../../../helpers/RoutingIDs';

export function hasStandorteGruppen(data: any) {
    const standorte: any[] = getStandorte(data) || [];
    return !!standorte.find((s: any) => s.gruppe_orig > 0);
}

export function getStandorteGruppen(data: any) {
    const standorte: any[] = getStandorte(data) || [];
    const gruppen: any = {
        no_group: []
    };
    standorte.forEach((s: any) => {
        if (s.gruppe_orig > 0) {
            if (!gruppen[s.gruppe]) {
                gruppen[s.gruppe] = [];
            }
            gruppen[s.gruppe].push(s);
        } else {
            gruppen.no_group.push(s);
        }
    });
    return gruppen;
}

export function getStandorteGruppenTabRoutings(data: any, basisRouting: any, basisTab: string, idxOffset: number = 0, addCustomChildrenSettings?: (childRouting: any, standort: any, tabIndex: number) => void): any[] {
    let gruppen: any = {};
    // const enableStandorteGruppen: boolean = config.devFeaturesMap && config.devFeaturesMap.N118_STANDORT_GRUPPIERUNG ? true : false;
    // const bereichKey = data[IDs.ENT_UNTERNEHMENSDATEN][0].bereich_key_orig;
    const bereichKey: string = (((data || {})[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
    const enableStandorteGruppen = bereichKey === 'kommunalverwaltung';
    if (enableStandorteGruppen) {
        gruppen = getStandorteGruppen(data);
    } else {
        gruppen.no_group = getStandorte(data) || [];
    }
    // gruppen = getStandorteGruppen(data);

    const standorteOhneGruppe = gruppen.no_group;
    delete (gruppen.no_group);
    const tabRoutings: any[] = Object.keys(gruppen).map((g: string, i: number) => {
        const tabIndex = idxOffset + i;
        const basisPath = {
            ...basisRouting,
            [basisTab]: tabIndex,
            terminateOn: basisTab
        };
        return {
            name: g,
            path: basisPath,
            children: gruppen[g].map((s: any, j: number) => {
                const childRouting = {
                    ...basisPath,
                    [RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM]: j,
                    terminateOn: RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM
                };
                return {
                    name: s.name,
                    dataRow: s,
                    path: childRouting,
                    ...(typeof addCustomChildrenSettings === 'function' ? addCustomChildrenSettings(childRouting, s, tabIndex) : {})
                };
            })
        };
    });

    const cnt = tabRoutings.length;
    standorteOhneGruppe.forEach((s: any, j: number) => {
        const tabIndex = idxOffset + cnt + j;
        const childRouting = {
            ...basisRouting,
            [basisTab]: tabIndex,
            terminateOn: basisTab
        };
        tabRoutings.push({
            name: s.name,
            dataRow: s,
            path: childRouting,
            ...(typeof addCustomChildrenSettings === 'function' ? addCustomChildrenSettings(childRouting, s, tabIndex) : {})
        });
    });
    return tabRoutings;
}

export function getStandorteTabRoutings(data: any, basisRouting: any, basisTab: string) {
    const standorte: any[] = getStandorte(data) || [];
    const tabRoutings: any[] = standorte.map((s: any, i: number) => {
        return {
            dataRow: s,
            name: s.name,
            path: {
                ...basisRouting,
                [basisTab]: i,
                terminateOn: basisTab
            }
        };
    });
    return tabRoutings;
}

export function findStandorteTabRouting(standortTid: number, data: any, basisRouting: any, basisTab: string, idxOffset: number = 0): any {
    let routingFnd;
    const tabRoutingAll = getStandorteGruppenTabRoutings(data, basisRouting, basisTab, idxOffset);
    tabRoutingAll.forEach((r: any) => {
        if (r.dataRow && r.dataRow.tid === standortTid) {
            routingFnd = r;
            return;
        }
        if (Array.isArray(r.children)) {
            const fnd = r.children.find((c: any) => c.dataRow && c.dataRow.tid === standortTid);
            if (fnd) {
                routingFnd = fnd;
                return;
            }
        }
    });
    return routingFnd;
}
